import { z } from "zod";

const geofenceSchema = z.object({
	coordinates: z.array(z.array(z.array(z.tuple([z.number(), z.number()])))),
	type: z.string(),
});
export const subsiteSchema = z.object({
	country_id: z.number(),
	description: z.string(),
	forest_type_id: z.number(),
	forest_type_name: z.string(),
	geofence: geofenceSchema.nullable(),
	id: z.number(),
	kelp_designated: z.number().optional(),
	kelp_ordered: z.number().optional(),
	kelp_planted: z.number().optional(),
	legacy: z.boolean(),
	legacy_kelp: z.number(),
	legacy_trees: z.number(),
	name: z.string(),
	region_id: z.number(),
	site_manager_name: z.string(),
	site_manager_title: z.string(),
	subsite_area: z.number(),
	subsite_main_image_url: z
		.object({
			cdn_url: z.string(),
			id: z.number(),
			url: z.string(),
		})
		.nullable(),
	total_planters: z.number(),
	trees_designated: z.number().optional(),
	trees_ordered: z.number().optional(),
	trees_planted: z.number().optional(),
	type: z.union([z.literal("Trees"), z.literal("Kelp")]),
});
export const regionSchema = z.object({
	center_lat: z.number().nullable(),
	center_lng: z.number().nullable(),
	center_long: z.number().nullable(),
	country_id: z.number(),
	geofence: geofenceSchema,
	id: z.number(),
	name: z.string(),
	organization: z.object({
		id: z.number(),
		name: z.string(),
	}),
	subsites: z.array(subsiteSchema),
});
export const plantingDataSchema = z.object({
	_result: z.object({
		http_code: z.number(),
	}),
	data: z.array(
		z.object({
			id: z.number(),
			lat: z.string(),
			long: z.string(),
			name: z.string(),
			regions: z.array(regionSchema),
		}),
	),
});
export type Geofence = z.infer<typeof geofenceSchema>;
export type Organization = RawRegionPlantingData["organization"];
export type PlantingDataResponse = z.infer<typeof plantingDataSchema>;
export type RawCountryPlantingData = PlantingDataResponse["data"][number];
export type RawRegionPlantingData = RawCountryPlantingData["regions"][number];
export type RawSubSite = RawRegionPlantingData["subsites"][number];
